import axios from "axios";

export const axiosBaseInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASE_URL_API_ENDPOINT,
});
